<div class="screen-lock" [ngClass]="{lock: isScreenLocked}">
  <ng-content></ng-content>
</div>
<cm-loader-progress-bar class="loader-progress" [progress]="progress$ | async" [ngClass]="{visible: isLoading}"></cm-loader-progress-bar>
